module.exports = "/lucky-balls/img/jackpot/018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/018.png
// module id = 1118
// module chunks = 0